import React from 'react'
import Head from 'next/head'
import Pitch from '@src/components/DisposalPage/Pitch'
import FeatureList from '@src/components/DisposalPage/FeatureList'
import Approach from '@src/components/DisposalPage/Approach'
import FAQ from '@src/components/DisposalPage/FAQ'
import SustainabilityDashboardPromo from '@src/components/DisposalPage/SustainabilityDashboardPromo'
import SchemaMarkup from '@src/components/SchemaMarkup'
import RelatedServices from '@src/components/RelatedServices'
import Clients from '@src/pages/LandingPage/Clients'
import Testimonials from '@src/pages/LandingPage/Testimonials'
import junkTestimonials from '@src/constants/junkTestimonials'
import TrustBox from '@src/pages/common/components/TrustBox'
import TrustedByClients from '@src/components/DisposalPage/TrustedByClients'
import pageClasses from '@src/styles/junk-removal-page.module.css'
// eslint-disable-next-line import/extensions
import piano from '../../json/piano-removal-data.json'

const pianoServiceData = {
  name: 'Piano Removal and Disposal',
  description:
    'Safe piano removal and recycling for homes and businesses nationwide. Dimension moves uprights, consoles, baby grands, and grands with an equipped crew, recovering iron, steel, and wood.',
  serviceType: 'Piano Removal',
  url: 'https://getdimension.com/piano-removal',
  provider: {
    name: 'Dimension',
    url: 'https://getdimension.com',
    address: {
      streetAddress: '2261 Market Street, #4061',
      addressLocality: 'San Francisco',
      addressRegion: 'CA',
      postalCode: '94114',
      addressCountry: 'US',
    },
    telephone: '+1 (415) 340-7182',
  },
  offers: [
    { name: 'Upright and Console Piano Removal' },
    { name: 'Grand and Baby Grand Piano Removal' },
    { name: 'Digital Piano Removal' },
    { name: 'On-Site Piano Disassembly' },
    { name: 'Piano Material Recycling' },
  ],
}

const pianoFAQData = {
  questions: piano.FAQContent.contentList.map((faq) => ({
    question: faq.heading.replace(/<[^>]*>/g, ''),
    answer: faq.textList.join(' '),
  })),
}

function PianoRemoval() {
  return (
    <>
      <Head>
        <title>Piano Removal &amp; Disposal Services | Dimension</title>
        <meta
          name="description"
          content="Safe piano removal and recycling nationwide. Dimension moves uprights, baby grands, and grand pianos with an equipped crew, handling stairs and disassembly, and recycles the materials."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://getdimension.com/piano-removal" />
        <SchemaMarkup type="WebSite" />
        <SchemaMarkup type="Service" data={pianoServiceData} />
        <SchemaMarkup type="FAQPage" data={pianoFAQData} />
        <SchemaMarkup type="LocalBusiness" />
      </Head>
      <div className={pageClasses.root}>
        <Pitch
          variant="hazardous-waste"
          heroImage="junk"
          heading={piano.pitch.heading}
          material={piano.pitch.material}
          pitchText={piano.pitch.pitchText}
          ctaLink={piano.pitch.ctaLink}
          ctaText={piano.pitch.ctaText}
          belowCta={<TrustBox isMobile isDark={false} />}
          belowPitch={<TrustedByClients />}
        />
        <Testimonials testimonials={junkTestimonials} />
        <Clients />
        <FeatureList {...piano.solutions} />
        <SustainabilityDashboardPromo />
        <FeatureList {...piano.benefits} />
        <Approach {...piano.approach} />
        <FAQ {...piano.FAQContent} />
        <RelatedServices
          services={[
            {
              label: 'Furniture Removal',
              href: '/furniture-removal',
              description:
                'Convenient removal of sofas, chairs, desks, and bulky furniture, with donation and recycling first.',
            },
            {
              label: 'Appliance Removal',
              href: '/appliance-removal',
              description:
                'Pickup and metal recycling of refrigerators, washers, ovens, and other appliances.',
            },
            {
              label: 'Junk Removal',
              href: '/junk-removal',
              description:
                'Full-service junk hauling and whole-home or office cleanouts, priced by volume.',
            },
            {
              label: 'Mattress Removal',
              href: '/mattress-removal',
              description:
                'Cheap mattress and bed-set disposal with recycling of steel, foam, and fiber.',
            },
          ]}
        />
      </div>
    </>
  )
}

export default PianoRemoval
